import type { IntlShape } from 'react-intl';
import type { SubscriptionFeature } from '@alltrails/types/SubscriptionFeature';
import liveShareSrc from './images/live-share-thumb.avif';

const liveShare = (intl: IntlShape): SubscriptionFeature => ({
  headline: intl.formatMessage({ defaultMessage: 'Live Share' }),
  subheadline: intl.formatMessage({ defaultMessage: 'Keep your loved ones in the loop by sharing your real-time trail activity' }),
  thumbnailImage: liveShareSrc.src
});

export default liveShare;
